export const RE_CAPTCHA_SITE_KEY = '6Lfr9LwZAAAAALlS5CqkzKrEfqKgfEwjz9E7asvq'; // https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do

export const RE_CAPTCHA_SITE_KEY_TEST = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
export const RE_CAPTCHA_SITE_KEY_INTELLECTUAL_PROPERTY_INFRINGEMENT = '6LdNO70fAAAAAAOLkW-h-SnNCB1RWfpG-sqeidL4';